import { FC } from "react";
import { StatisticsObjectType } from "../caseVolumeLineChart/types";
import { Link, useSearchParams } from "react-router-dom";
import CustomPieChart from "../customPieChart";



const CustomComponentDoctor: FC<StatisticsObjectType> = ({ StatisticsObjectType ,title,drug, isFullRow, caseData }): JSX.Element => {

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [searchParams, updateSearchParams] = useSearchParams();

  // console.log("searchparam.....",searchParams.get("userId"))
  // const findPath = () => {
  //   if(title === "Area Manager") {
  //     return '/regions'
  //   } else if(title === "Regional Manager") {
  //     return '/districts'
  //   } else if(title === "Reps") {
  //     return '/territories'
  //   } else if(title === "Practices") {
  //     return '/practice_stats'
  //   } else if (title === "Doctors") {
  //     return "/doctor_stats"
  //   } else if (title === "Areas") {
  //     return "/regions"
  //   } else if (title === "Regions") {
  //     return "/districts"
  //   }else if (title === "Territories") {
  //     return "/territories"
  //   }
  //   // else if(title === "district_manager"){
  //   //   return '/districts'
  //   // }
  // }
  const doctors = StatisticsObjectType.doctors || [];
  const totalCounts = doctors.reduce((sum, item) => sum + (item?.plan_type_data[0]?.count || 0), 0);
  const totalCases = doctors.reduce((sum, item) => sum + Number(item?.plan_type_data[0]?.cases_total || 0), 0);
  return (
    <>
        <div className={isFullRow ? "col-12 col-md-6 col-sm-12" : "col-12 col-md-4 col-sm-12"}>
            <CustomPieChart title={"Cases By Submission Mode"} pieChartObject={StatisticsObjectType.mos} />
        </div>
        <div className={isFullRow ? "col-12 col-md-6 col-sm-12 d-flex" : "col-12 col-md-4 col-sm-12 d-flex"}>
        <div className="flex-fill card">
          <div className="card-header">
            <h4 className="m-0">{title}</h4>
          </div>
          <div className="card-body p-0 overflow-y-auto" style={{maxHeight:'434px'}}>
            <table className="table table-hover table-striped table-responsive">
              <thead className="table-light">
                <tr className="text-center">
                  <th>Provider</th>
                  {drug.includes('iovera') ? <th>iovera°</th>: drug.includes('zilretta') ? <th>ZILRETTA</th> : <th>ZILRETTA / iovera°</th>}
                  <th>Total Cases</th>
                </tr>
              </thead>

              <tbody>
                {StatisticsObjectType.doctors && StatisticsObjectType.doctors && StatisticsObjectType.doctors.length > 0 ?
                  StatisticsObjectType.doctors.map((item, key) =>
                    <tr className="text-center" key={key}>
                      <td>
                        <Link
                          to={{
                            pathname: '/territories',
                            search: (() => {
                              const newParams = new URLSearchParams()
                              newParams.set("userId",item?.doctor_id.toString() || "")
                              newParams.set("role","doctor")
                              newParams.set("doc_name", item.doctor_name)
                              newParams.set("drug",searchParams.get('drug') || drug || "")
                              newParams.set("type", "doc_stats")
                              return newParams.toString();
                            })(),
                          }}
                          reloadDocument
                        >
                          {item.doctor_name}
                        </Link>
                      </td>
                      <td className="text-center text-dark">{item?.plan_type_data[0].count}</td>
                      <td className="text-center text-dark">{item?.plan_type_data[0].cases_total}</td>
                    </tr>
                  ) : (
                    <>
                      {searchParams.get("doc_name") ? (
                        <tr className="text-center">
                          <td>
                            <span>{searchParams.get("doc_name")}</span>
                          </td>
                          <td className="text-center text-dark">{caseData?.drug_cases}</td>
                          <td className="text-center text-dark">{caseData?.total_case}</td>
                        </tr>
                      ) : null}
                    </>
                  )
                }
              </tbody>

              <tfoot>
                <tr className="text-center">
                  <td className="fw-bold">Total</td>
                  <td className="fw-bold">{totalCounts || caseData?.drug_cases}</td>
                  <td className="fw-bold">{totalCases || caseData?.total_case}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomComponentDoctor;
